module.exports = __webpack_public_path__ + "img/public/siteImages/forgotCarBg.png?87c02dcf";